import React, { useMemo } from "react";
import {
  useTable,
  useRowSelect,
  useFilters,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import Checkbox from "../Checkbox/Checkbox";
import { formatDate } from "../../utils/common-utils";
import "./CustomTable.css";
import "../../styles/Table.css";

const CustomTable = ({
  data,
  enabledColumns,
  onAction,
  currentPage,
  pageSize,
}) => {
  const columns = useMemo(() => {
    const srNoColumn = {
      Header: "S.no",
      id: "srNo",
      Cell: ({ row }) => row.index + 1 + currentPage * pageSize,
    };
console.log("enabledColumns", data);
    const dataColumns = enabledColumns.map((columnKey) => ({
      Header: columnKey
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim(),
      accessor: columnKey,
      Cell: ({ value, row }) => {
        if (columnKey === "action") {
          return (
            <div className="d-flex gap-2 align-items-center justify-content-center">
              {row.original.actions?.map((action, index) => {
                if (
                  action.action === "ChangePassword" &&
                  row.original.status === "Draft"
                ) {
                  return null;
                }

                if (action.action === "Change Status") {
                  return (
                    <div className="form-check form-switch m-0" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        title="Change Status"
                        style={{ cursor: "pointer" }}
                        checked={row.original.enabled || row.original.status == 1}
                        onChange={() => handleAction(action, row.original)}
                      />
                    </div>
                  );
                }
                return (
                  <i
                    key={index}
                    className={`${action.iconName} ${action.colorCode}`}
                    style={{ color: action.colorCode, cursor: "pointer" }}
                    title={action.titleName}
                    onClick={() => handleAction(action, row.original)}
                  />
                  
                );
              })}
            </div>
          );
        }
        if (columnKey === "dateTime") {
          return formatDate(value);
        }
       
        if (columnKey === "enabled") {
          return (
            <span className={`badge ${value ? 'bg-success' : 'bg-danger'}`}>
              {value ? "Active" : "Inactive"}
            </span>
          );
        }
        if (columnKey === "createdDate") {
          return formatDate(value);
        }
        // if (columnKey === "status") {
        //   return <span className="badge text-bg-success">{value}</span>;
        // }
        // if (columnKey ==="status") {
        //   <span className="badge text-bg-success">{value}</span>;
        //   if (value == true) {
        //     return <span className="badge text-bg-success">Active</span>;
        //   } else {
        //     return <span className="badge text-bg-danger">Inactive</span>;
        //   }
        // }
        if(columnKey === "status"){
          if (value === true || value == 1 || value === "Active") {
            return <span className="badge text-bg-success">Active</span>;
          } else if (value === false || value === 0 || value === 2 || value === "Inactive") {
            return <span className="badge text-bg-danger">Inactive</span>;
          } else {
            return <span className="badge text-bg-secondary">N/A</span>;
        }
      }
        if (columnKey === "environment") {
          if (value == "Production") {
            return <span class="badge text-bg-success">{value}</span>;
          } else {
            return <span class="badge text-bg-warning">{value}</span>;
          }
        }
        if (columnKey === "status") {
          if (value === true) {
            return <span className="badge text-bg-success">Active</span>;
          } else {
            return <span className="badge text-bg-danger">Inactive</span>;
          }
        }
        if (columnKey ==="enabled") {
          if (value == "true") {
            return <span className="badge text-bg-success">Active</span>;
          } else {
            return <span className="badge text-bg-danger">Inactive</span>;
          }
        }
        if (columnKey === "status") {
          if (value == "Active") {
            return <span class="badge text-bg-success">{value}</span>;
          }
          if (value == true) {
            return <span class="badge text-bg-success">{value}</span>;
          } else {
            return <span class="badge text-bg-danger">{value}</span>;
          }
          
        }
        
        if (columnKey === "role") {
          console.log("rolesee", value);
          if (value == "Admin") {
            return <span class="badge text-bg-success">{value}</span>;
          } else if (value == "Mis Management") {
            return <span class="badge text-bg-warning">{value}</span>;
          } else if (value == "Consent Gateway") {
            return <span class="badge text-bg-info">{value}</span>;
          } else if (value == "Customer Care") {
            return <span class="badge text-bg-primary">{value}</span>;
          } else {
            return <span class="badge text-bg-danger">{value}</span>;
          }
        }
        return value;
      },
    }));

    return [srNoColumn, ...dataColumns];
  }, [enabledColumns]);

  const handleAction = (action, rowData) => {
    if (action.action === "Change Status") {
      const newStatus = rowData.status === 1 ? 0 : 1;
      onAction?.(action, rowData, newStatus);
    } else {
      onAction?.(action, rowData);
    }
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow  } =
    useTable(
      {
        columns,
        data,
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
      useRowSelect
      // (hooks) => {
      //   hooks.visibleColumns.push((columns) => {
      //     return [
      //       {
      //         id: "selection",
      //         Header: ({ getToggleAllRowsSelectedProps }) => (
      //           <Checkbox {...getToggleAllRowsSelectedProps()} />
      //         ),
      //         Cell: ({ row }) => (
      //           <Checkbox {...row.getToggleRowSelectedProps()} />
      //         ),
      //       },
      //       ...columns,
      //     ];
      //   });
      // }
    );

  return (
    <div className="table-responsive">
      <table
        {...getTableProps()}
        className="table table-bordered table-striped"
        id="printableTable"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              className="bg-transparent "
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}{" "}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <i className="fa-solid fa-arrow-up"></i>
                      ) : (
                        <i className="fa-solid fa-arrow-down"></i>
                      )
                    ) : (
                      <i className="fa-solid fa-arrows-up-down"></i>
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    className={
                      cell.column.Header == "S.no"
                        ? "text-end pe-3"
                        : cell.column.Header == "Action" ||
                          cell.column.Header == "Status" ||
                          cell.column.Header == "Environment" ||
                          cell.column.Header == "Role"
                        ? "text-center"
                        : "text-start ps-2"
                    }
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CustomTable;
